var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5C16.4062 13.5 13.5 16.4062 13.5 20C13.5 23.5938 16.4062 26.5 20 26.5C23.5938 26.5 26.5 23.5938 26.5 20C26.5 16.4062 23.5938 13.5 20 13.5ZM20 28C15.5938 28 12 24.4062 12 20C12 15.5938 15.5938 12 20 12C24.4062 12 28 15.5938 28 20C28 24.4062 24.4062 28 20 28ZM18.75 22.5H19.5V20.5H18.75C18.3438 20.5 18 20.1562 18 19.75C18 19.3438 18.3438 19 18.75 19H20.25C20.6562 19 21 19.3438 21 19.75V22.5H21.25C21.6562 22.5 22 22.8438 22 23.25C22 23.6562 21.6562 24 21.25 24H18.75C18.3438 24 18 23.6562 18 23.25C18 22.8438 18.3438 22.5 18.75 22.5ZM20 18C19.4375 18 19 17.5625 19 17C19 16.4375 19.4375 16 20 16C20.5625 16 21 16.4375 21 17C21 17.5625 20.5625 18 20 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d7d01c33a28b96f42fb24c219e05592d.svg";
export { ForwardRef as ReactComponent };